const scene = "fees/";
export const UPDATE_BUNDLE_FEES = `${scene}UPDATE_BUNDLE_FEES`;
export const UPDATE_CUSTOM_FEES = `${scene}UPDATE_CUSTOM_FEES`;